<div class="row mb-3 px-0">
  <div class="col">
    <div class="content-block-head mb-3 p-3">
      <h4>Company Settings</h4>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label>Company Name</label>
        <input class='form-control' type="text" [(ngModel)]='this.environment.companyName' [class.is-valid]='this.environment.companyName !== ""' [class.is-invalid]='this.environment.companyName === ""'/>
      </div>
      <div class="col-md-6">
        <label>Company Number</label>
        <input class='form-control' type="text" [(ngModel)]='this.environment.comnpanyNumber' [class.is-valid]='this.environment.comnpanyNumber !== ""' [class.is-invalid]='this.environment.comnpanyNumber === ""'/>
      </div>
      <div class="col-md-6">
        <label>QR Code Colour (Colour name or Hexcode - https://htmlcolorcodes.com/)</label>
        <input class='form-control' type="text" [(ngModel)]='this.environment.qrFillColor'/>
      </div>
      <div class="col-md-6">
        <label>QR Watermark Image (base64 encoded) - https://www.base64-image.de/</label>
        <input class='form-control' type="text" [(ngModel)]='this.environment.qrImage'/>
      </div>
    </div>
  </div>
</div>

<div class="row mb-3">
  <div class="col">
    <div class="content-block-head mb-3 p-3">
      <h4>System Settings</h4>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label>Default Tare Weight Unit</label>
        <input class='form-control' type="text" [(ngModel)]='this.environment.defaultTareWeightUnit'/>
      </div>
      <div class="col-md-6">
        <label>Quotenumber Prefix</label>
        <input class='form-control' type="text" [(ngModel)]='this.environment.defaultQuoteNoPrefix'/>
      </div>
      <div class="col-md-6">
        <label>Employee Number Prefix</label>
        <input class='form-control' type="text" [(ngModel)]='this.environment.defaultEmployeeNoPrefix'/>
      </div>
      <div class="col-md-6">
        <label>Default Weighbridge Depot</label>
        <select class='form-control' (change)='this.environment.defaultWeighbridgeDepot = +$event.target.value;'>
          <option value='-1'>No Default Depot...</option>
          @for (item of this.depots; track item) {
            <option [value]='item.id' [selected]='this.environment.defaultWeighbridgeDepot === item.id'>{{ item.name }}</option>
          }
        </select>
      </div>
      <div class="col-md-6">
        <label>Default Vehicle Depot</label>
        <select class='form-control' (change)='this.environment.defaultVehicleDepot = +$event.target.value;'>
          <option value='-1'>No Default Depot...</option>
          @for (item of this.depots; track item) {
            <option [value]='item.id' [selected]='this.environment.defaultVehicleDepot === item.id'>{{ item.name }}</option>
          }
        </select>
      </div>
    </div>
  </div>
</div>

<div class="row mb-3">
  <div class="col">
    <div class="content-block-head mb-3 p-3">
      <h4>Invoicing Settings</h4>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label>Invoice Prefix</label>
        <input class='form-control' type="text" [(ngModel)]='this.environment.invoicePrefix'/>
      </div>
      <div class="col-md-6">
        <label>Invoice Terms</label>
        <input class='form-control' type="text" [(ngModel)]='this.environment.invoiceTerms'/>
      </div>
      <div class="col-md-6">
        <label>Invoice Comments</label>
        <input class='form-control' type="text" [(ngModel)]='this.environment.invoiceComments'/>
      </div>

      <div class="col-md-12">
        <hr>
        </div>

        <div class="col-md-6">
          <label>Address 1</label>
          <input
            class='form-control'
            type="text"
            [(ngModel)]='this.environment.address1'
            [class.is-valid]='this.environment.address1 !== ""'
            [class.is-invalid]='this.environment.address1 === ""'
            />
        </div>
        <div class="col-md-6">
          <label>Address 2</label>
          <input
            class='form-control'
            type="text"
            [(ngModel)]='this.environment.address2'
            [class.is-valid]='this.environment.address2 !== ""'
            [class.is-invalid]='this.environment.address2 === ""'
            />
        </div>
        <div class="col-md-6">
          <label>Town/City</label>
          <input class='form-control' type="text" [(ngModel)]='this.environment.addressCity'/>
        </div>
        <div class="col-md-6">
          <label>Country</label>
          <input class='form-control' type="text" [(ngModel)]='this.environment.addressCountry'/>
        </div>
        <div class="col-md-6">
          <label>Postcode</label>
          <input
            class='form-control'
            type="text"
            [(ngModel)]='this.environment.addressPostcode'
            [class.is-valid]='this.environment.addressPostcode !== ""'
            [class.is-invalid]='this.environment.addressPostcode === ""'
            />
        </div>
        <div class="col-md-6">
          <label>Contact Email</label>
          <input
            class='form-control'
            type="email"
            [(ngModel)]='this.environment.addressEmail'
            [class.is-valid]='this.environment.addressEmail !== ""'
            [class.is-invalid]='this.environment.addressEmail === ""'
            />
        </div>
        <div class="col-md-6">
          <label>Phone</label>
          <input
            class='form-control'
            type="text"
            [(ngModel)]='this.environment.addressPhone'
            [class.is-valid]='this.environment.addressPhone !== ""'
            [class.is-invalid]='this.environment.addressPhone === ""'
            />
        </div>

        <div class="col-md-12">
          <hr>
            <span>
              To insert company name, use %REPLACE%. HTML tags can be used for formatting.
            </span>
          </div>

          <div class="col-md-6">
            <label>Waste Transfer Terms (Left Block)</label>
            <textarea class='form-control' rows='15' [(ngModel)]='this.environment.wasteTransferTermsBlockA'></textarea>
          </div>
          <div class="col-md-6">
            <label>Waste Transfer Terms (Right Block)</label>
            <textarea class='form-control' rows='15' [(ngModel)]='this.environment.wasteTransferTermsBlockB'></textarea>
          </div>
        </div>
      </div>
    </div>

<div class="row mb-3">
  <div class="col">
    <div class="content-block-head mb-3 p-3">
      <h4>Storage Charges</h4>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label>Extra storage days after leaving</label>
        <input class='form-control' type="number" min="0" max="7" [(ngModel)]='this.environment.storageExtraDays'/>
        <small class="text-muted">Stock is charged from the day it arrives through the day it leaves, plus this many days.</small>
      </div>
    </div>
  </div>
</div>

<div class="row mb-3">
  <div class="col">
    <div class="content-block-head mb-3 p-3">
      <h4>Label Printing</h4>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label>Print Mode</label>
        <select class='form-control' [(ngModel)]='this.environment.labelPrintMode'>
          <option value='zebra'>Zebra label printer (one label per page)</option>
          <option value='sheet'>A4 sheet</option>
        </select>
      </div>
      @if (this.environment.labelPrintMode !== 'sheet') {
        <div class="col-md-4">
          <label>Label Size</label>
          <select class='form-control' (change)='this.onLabelPresetChanged($event.target.value)'>
            @for (preset of this.labelSizePresets; track preset.name; let i = $index) {
              <option [value]='i' [selected]='this.getLabelPreset() === "" + i'>{{ preset.name }}</option>
            }
            <option value='custom' [selected]='this.getLabelPreset() === "custom"'>Custom size</option>
          </select>
        </div>
        @if (this.getLabelPreset() === 'custom') {
          <div class="col-md-2">
            <label>Width (mm)</label>
            <input class='form-control' type="number" [min]='this.minLabelMm' [max]='this.maxLabelMm'
              [(ngModel)]='this.environment.labelWidthMm'
              [class.is-invalid]='!this.isLabelDimensionValid(this.environment.labelWidthMm)'/>
          </div>
          <div class="col-md-2">
            <label>Height (mm)</label>
            <input class='form-control' type="number" [min]='this.minLabelMm' [max]='this.maxLabelMm'
              [(ngModel)]='this.environment.labelHeightMm'
              [class.is-invalid]='!this.isLabelDimensionValid(this.environment.labelHeightMm)'/>
          </div>
        }
        <div class="col-md-12 mt-2">
          <small class="text-muted">
            Set the Zebra printer driver to the same label stock. When printing, choose Margins: None and Scale: 100.
            Sizes must be between {{ this.minLabelMm }} and {{ this.maxLabelMm }} mm.
          </small>
        </div>
      }
    </div>
  </div>
</div>

